import styled from 'styled-components';
import { BaseSection } from '../components/styles';

export const Container = styled.div`
  position: relative;
  #id-homepage-bodyshop-image-1 {
    object-fit: cover;
    object-position: 16%;
  }
  #id-homepage-bodyshop-image-2 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-bodyshop-image-3 {
    object-fit: cover;
    object-position: 90%;
    transform: rotateY(180deg);
  }
  #id-homepage-bodyshop-image-4 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-bodyshop-image-5 {
    object-fit: cover;
    object-position: 90%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
  }
`;

export const FirstSection = styled(BaseSection)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme }) => theme.white};
  text-align: left;
  padding-top: 6rem;

  > button {
    align-items: center;
  }
  > div {
    gap: 1rem;
  }
`;

export const TitleSection = styled.div`
  color: #3f5ec9;
`;

export const ImageLine = styled.img`
  position: absolute;
  margin: 1rem 0;
  width: 33%;
  top: 17%;
  left: 70%;
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    position: absolute;
    top: 3%;
    left: 70%;
    width: 60%;
    height: auto;
  }
`;

